import React, { Component } from 'react'
import Button from 'components/button/button'
import ProfilePicture from 'components/profile/profile-picture'
import Icon from 'components/icon/icon'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'

import { 
	doSort,
	formatStandardDateTime,
	getBaseSlugFromPath
} from 'utils'

class TeamGroup extends Component {
	state = {
		hasMountedWithDelay: false
	}

	componentDidMount() {
		setTimeout(_ => {
			this.setState({
				hasMountedWithDelay: true
			})
		},1)
	}

	render() {
		const {
			item,
			allUsers,
			editTeam,
			deleteTeam,
			canEditTeam,
			openTeamChat,
			match,
			isMini,
			accountUsers
		} = this.props

		const team = item

		const {
			hasMountedWithDelay
		} = this.state

		const buttonProps = canEditTeam ? [
			{
				size: 'small',
				level: 'x-low',
				callback: _ => {
					openTeamChat(team)
				},
				label: 'Open team chat',
				icon: 'fe-mail'
			},
			{
				size: 'small',
				level: 'x-low',
				callback: _ => {
					editTeam(team)
				},
				label: 'Edit team',
				icon: 'fe-edit-2',
			},{
				size: 'small',
				level: 'x-low',
				callback: _ => {
					deleteTeam(team)
				},
				label: 'Delete team',
				icon: 'fe-trash-2'
			}
		] : []

		let teamUsers = []

		team.userIds.forEach(userId => {
			const user = accountUsers.find(loopedUser => {
				return loopedUser.id === userId
			})

			if(user && user.id){
				teamUsers.push(user)
			}
		})

		teamUsers = doSort(teamUsers, 'alpha', 'first_name')

		let subtitle = `${ teamUsers.length } member${ teamUsers.length !== 1 ? 's' : '' }, ${ team.projectIds.length } project${ team.projectIds.length !== 1 ? 's' : '' }`

		if(!isMini){
			subtitle += ` • Created ${ formatStandardDateTime(team, 'created_at', true) }`

			let creator = null

			if(team.user_id){
				creator = accountUsers.find(loopedUser => {
					return loopedUser.id === team.user_id
				})
			}

			if(creator && !isMini){
				subtitle += ' by '+creator.first_name+' '+creator.last_name
			}
		}

		const teamUrl = getBaseSlugFromPath(match.path)+'/people/teams/'+team.id

		return (
			<li>
				<div 
					className={hasMountedWithDelay ? "team-group visible" : "team-group"}
					onClick={isMini ? this.openGroup : null}
				>
					<Link 
						className="team-group-top"
						onClick={this.openGroup}
						to={teamUrl}
					>
						<h2>
							{ team.name }	
						</h2>
						<div 
							className="team-group-controls" 
							onClick={e => {
								e.preventDefault()
								e.stopPropagation()
							}}
						>
							{ buttonProps.map((buttonProp, index) => {
								return(
									<div key={index}>
										<Button { ...buttonProp } />
									</div>
								)
							}) }
						</div>
						<span>
							{ subtitle }
						</span>
					</Link>
					{ teamUsers.length ?
						<div className="team-group-users">
							<ul>
							{ teamUsers.map((user, index) => {
								if(!user){
									return null
								}

								const url = getBaseSlugFromPath(match.path)+'/people/staff/'+user.id

								const isAdmin = team.adminIds.find(adminId => {
									return adminId == user.id
								})

								return (
									<li style={{
										transitionDelay: (index/10)+'s'
									}} key={user.id}>
										<Link 
											to={url}
											onClick={e => e.stopPropagation()}
										>
											{ isAdmin ?  
												<span className="admin-dot tooltip-trigger">
													<Icon name="star" />
													<div className="tooltip">
														Team admin
													</div>
												</span>
											: null}
											<div className="tooltip-trigger">
												<ProfilePicture
													user={user}
												/>
												<div className="tooltip">
													{ user.first_name+' '+user.last_name }
												</div>
											</div>
										</Link>
									</li>
								)
							}) }
							</ul>
						</div>
					: null }
				</div>
			</li>
		)
	}
}


export default withRouter(TeamGroup)